<template>
  <div class="service">
    <img v-bind:src="imgUrl"  class="icon"/>
    <div class="hr"></div>
    <h2>{{ title }}</h2>
    <p>{{ desc }}</p>
  </div>
</template>

<script>
  export default {
    name: 'service',
    props: {
      imgUrl: String,
      title: String,
      desc: String
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/scss/_variables";

  .service {
    color: $dark-grey;
    text-align: center;
    margin: 20px $margin-left;
    font-family: $title-font;

    img {

      height: 120px;

      @media screen and (min-width: $screen-L-min) {
        height: 187px;
      }
    }

    @media screen and (min-width: $tablet-min) and (max-width: $tablet-max) {
      width: 80%;
      margin: 40px auto;
    }

    @media screen and (min-width: $screen-min) and (max-width: $screen-max) {
      margin: 0;
      width: 40%;
      float: left;
      padding: 0 5%;
    }

    @media screen and (min-width: $screen-L-min) {
      margin: 0;
      width: 33%;
      float: left;
      padding: 0;
    }

    h2 {
      font-size: 21px;
      font-weight: 600;
      text-align: left;
      margin: 0;
      margin-top: 20px;

      @media screen and (min-width: $screen-L-min) {
        padding: 20px 20% 0px 20%;
      }
    }

    .hr {
      height: 3px;
      background-color: $light-grey;
      margin: auto;
      width: 68px;

      @media screen and (min-width: $screen-L-min) {
        height: 4px;
        width: 100px;
      }
    }

    p {
      font-size: 16px;
      line-height: 1.6em;
      text-align: left;

      @media screen and (min-width: $screen-L-min) {
        padding: 20px 15% 50px 15%;
      }
    }
  }


</style>
